import { defineComponent, h } from 'vue';
import BaseComponent from './BaseComponentMixin.jsx';
import './css/BasicButton.css';
import token from '@/Services/token';

export default defineComponent({
    name: 'sound-player',
    mixins: [BaseComponent],
    data: function () {
        return {
            audio: null,
            blobUrl: null,
            State: 'Stopped',
        }
    },
    //Mounted Replaced with preRenderComplete
    computed: {
    },
    methods: {
        preRenderComplete() {
            this.finishRenderHandler(this);
        },
        PlaySound(fn) {
            let src;
            if (fn.startsWith('http'))
                src = fn;
            else 
                src = new URL(fn, token.GetApiBaseURL()).href;
            
            const this_ref = this;

            console.log("PlaySound URL:", src);

            fetch(src, {
                method: "GET",
                mode: "cors",
                credentials: "include",
                headers: {
                    "access_token": token.AccessToken()
                }
            })
                .then((response) => {
                    if (!response.ok) {
                        // 4xx/5xx → server error
                        return response.text().then(text => {
                            throw new Error(`Server error ${response.status}: ${text.slice(0, 200)}`);
                        });
                    }

                    const contentType = response.headers.get('Content-Type') || '';
                    console.log('Response contentType:', contentType);

                    return response.blob();
                })
                .then((audioBlob) => {
                    console.log("Blob size:", audioBlob.size);
                    console.log("Blob type:", audioBlob.type);

                    this.blobUrl = URL.createObjectURL(audioBlob);

                    console.log("Blob URL:", this.blobUrl);

                    this.audio = new Audio();
                    this.audio.crossOrigin = "use-credentials";
                    this.audio.src = this.blobUrl;
                    this.audio.addEventListener("canplaythrough", event => {
                        this_ref.State = 'Playing';
                    });
                    this.audio.addEventListener("ended", function () {
                        this_ref.State = 'Stopped';
                        if (this.blobUrl) {
                            URL.revokeObjectURL(this.blobUrl);
                            this.blobUrl = null;  // clear reference
                        }
                    });
                    this.State = 'Loading';
                    this.audio.play();
                });           
        },
        Stop() {
            if (this.audio instanceof Audio) {
                this.audio.pause();
                this.audio = undefined;
                if (this.blobUrl) {
                    URL.revokeObjectURL(this.blobUrl);
                    this.blobUrl = null;
                }
            }
            this.State = 'Stopped';
        }
    },
    props: {
    },
    render() {
        return null;
    }
});